import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
    IRuleSchedule,
    ICreateRuleScheduleRequest,
    IUpdateRuleScheduleRequest,
    IRuleScheduleLinkResult,
} from '../../models/rule-schedule.interface';

@Injectable({
    providedIn: 'root',
})
export class RuleScheduleService {
    readonly endpoints = {
        schedules: `${environment.apiUrl}/rule-schedules`,
        link: `${environment.apiUrl}/rule-schedules/link`,
        unlink: `${environment.apiUrl}/rule-schedules/unlink`,
        forRule: `${environment.apiUrl}/rule-schedules/rule`,
    };

    private http: HttpClient = inject(HttpClient);

    getSchedules(): Observable<IRuleSchedule[]> {
        return this.http.get<IRuleSchedule[]>(this.endpoints.schedules);
    }

    createSchedule(body: ICreateRuleScheduleRequest): Observable<IRuleSchedule> {
        return this.http.post<IRuleSchedule>(this.endpoints.schedules, body);
    }

    updateSchedule(body: IUpdateRuleScheduleRequest): Observable<IRuleSchedule> {
        return this.http.put<IRuleSchedule>(this.endpoints.schedules, body);
    }

    deleteSchedules(ids: string[]): Observable<IRuleSchedule[]> {
        return this.http.request<IRuleSchedule[]>('DELETE', this.endpoints.schedules, {
            body: { ids },
        });
    }

    getSchedulesForRule(ruleId: string): Observable<IRuleSchedule[]> {
        return this.http.get<IRuleSchedule[]>(
            `${this.endpoints.forRule}/${encodeURIComponent(ruleId)}`,
        );
    }

    link(ruleIds: string[], scheduleIds: string[]): Observable<IRuleScheduleLinkResult> {
        return this.http.post<IRuleScheduleLinkResult>(this.endpoints.link, {
            rule_ids: ruleIds,
            schedule_ids: scheduleIds,
        });
    }

    unlink(ruleIds: string[], scheduleIds: string[]): Observable<IRuleScheduleLinkResult> {
        return this.http.post<IRuleScheduleLinkResult>(this.endpoints.unlink, {
            rule_ids: ruleIds,
            schedule_ids: scheduleIds,
        });
    }
}
